import React, { useState, useCallback, useMemo } from 'react'
import { Input, CheckBox } from '../../Form/Form'
import Button from 'react-bootstrap/Button'
import Box from './Styled/Box'
import Controllers from '../../../Api/Controllers'
import Helpers from '../../Helpers/Helpers'
import { toast } from 'react-toastify';

const Login = ({ type = '' }) => {
  const isLoginCustomers = type === 'empresariosindependientes'

  const [session, setSession] = useState({
    username: '',
    password: '',
  })

  const [changePassword, setChangePassword] = useState(false)
  const [newPassword, setNewPassword] = useState({
    newPassword: '',
    confirmPassword: '',
    username: ''
  })

  const [forgotPassword, setForgotPassword] = useState(false)
  const [recoveryEmail, setRecoveryEmail] = useState('')

  const dataSubmit = useCallback(() => {
    if (changePassword) {
      return {
        p_new_password: newPassword.newPassword,
        p_username: newPassword.username,
      }
    }

    return {
      p_username: session.username,
      p_password: session.password,
      p_type: isLoginCustomers ? 1 : 2
    }
  }, [changePassword, isLoginCustomers, newPassword.newPassword, newPassword.username, session.password, session.username])

  const [isLoadingRecovery, setIsLoadingRecovery] = useState(false);

  const handleSubmit = e => {
    e.preventDefault()
    let $this = e.target

    if (!$this.checkValidity()) {
      $this.classList.add('was-validated')
    } else {
      $this.classList.remove('was-validated')

      let button = $this.querySelector('button');
      let buttonHTML = button.innerHTML;
      button.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>'

      if (!changePassword) {
        Controllers.users.get_login(dataSubmit()).then(res => {
          if (res.response === 'success') {
            Helpers.localStorage.setSession({
              jwt: res.data.jwt
            });
            Helpers.toast.construct({ ...res, toast });
            window.location.href = Helpers.config.convertUrl({ url: '/' });
          } else {
            if (res?.data?.status === 'CHANGE_PASSWORD') {
              Helpers.toast.construct({
                response: 'info', message: res.message, toast, options: {
                  position: 'top-center'
                }
              });
              button.innerHTML = buttonHTML;
              setNewPassword({
                ...newPassword, username: session.username
              })
              setChangePassword(true)
            } else {
              Helpers.toast.construct({ ...res, toast });
              button.innerHTML = buttonHTML;
            }
          }
        }).catch(req => {
          Helpers.promise.catch({ req, toast });
          button.innerHTML = buttonHTML;
        });
      } else {
        if (newPassword.confirmPassword !== newPassword.newPassword) {
          Helpers.toast.construct({
            response: 'warning', message: 'Las contraseñas no coinciden', toast
          });
          button.innerHTML = buttonHTML;
          return;
        }

        Controllers.users.change_password(dataSubmit()).then(res => {
          Helpers.toast.construct({ ...res, toast });
          button.innerHTML = buttonHTML;

          if (res.response === 'success') {
            setNewPassword({
              newPassword: '',
              confirmPassword: '',
              username: ''
            })
            setSession({
              username: '',
              password: ''
            })
            setChangePassword(false)
          }
        }).catch(req => {
          Helpers.promise.catch({ req, toast });
          button.innerHTML = buttonHTML;
        });
      }
    }
  }

  const handleRecoverySubmit = (e) => {
    e.preventDefault();

    const form = e.target;
    if (!form.checkValidity()) {
      form.classList.add('was-validated');
      return;
    } else {
      form.classList.remove('was-validated');
    }

    setIsLoadingRecovery(true);

    Controllers.users.send_recovery_email({ p_email: recoveryEmail })
      .then(res => {
        Helpers.toast.construct({ ...res, toast });
        if (res.response === 'success') {
          setForgotPassword(false);
          setRecoveryEmail('');
        }
      })
      .catch(req => {
        Helpers.promise.catch({ req, toast });
      })
      .finally(() => {
        setIsLoadingRecovery(false);
      });
  }

  const imageBackground = useMemo(() => {
    return Helpers.config.resourcesUrl({ url: '/images/dashboard/system-devs-login-background-v2.png?v=2' })
  }, [type])

  return <>
    <div style={{
      position: 'fixed',
      height: '100%',
      width: '100%',
      background: 'linear-gradient(118deg, #d9e9eb, #7faab3)'
    }}></div>
    <Box backgroundImage={imageBackground}>
      <Box.Container>
        <Box.Content className="form-row modern-auth-card">
          <div className="col-12 text-center mb-4">
            <div className="system-devs-auth-brand"><span>SD</span><strong>System Devs</strong></div>
            <div className="modern-auth-copy">
              <span>Plataforma empresarial</span>
              <h1>{isLoginCustomers ? 'Bienvenido a tu red' : 'Centro de operaciones'}</h1>
              <p>Ingresa tus datos para continuar.</p>
            </div>
          </div>

          {forgotPassword && (
            <form onSubmit={handleRecoverySubmit} className="col-12 needs-validation" noValidate>
              <div className="form-row">
                <Input
                  type="email"
                  placeholder="Correo electrónico"
                  icon="fa fa-envelope"
                  classNameParent="col-12 mb-3"
                  required
                  value={recoveryEmail}
                  onChange={e => setRecoveryEmail(e.currentTarget.value)}
                />
                <div className="col-12 mt-4">
                  <Button
                    type="submit"
                    variant="primary"
                    block
                    style={{ height: '50px' }}
                    disabled={isLoadingRecovery}
                  >
                    {isLoadingRecovery ? (
                      <i className="fa fa-circle-notch fa-spin" />
                    ) : (
                      'Enviar código de recuperación'
                    )}
                  </Button>
                </div>
                <div className="col-12 mt-2 text-center">
                  <Button
                    variant="link"
                    onClick={e => {
                      e.preventDefault();
                      setForgotPassword(false);
                    }}
                    style={{ fontSize: '0.9rem' }}
                  >
                    ← Volver al inicio de sesión
                  </Button>
                </div>
              </div>
            </form>
          )}


          {!forgotPassword && <form onSubmit={handleSubmit} autoComplete="off" className="col-12 needs-validation" noValidate>
            <div className="form-row">

              {!changePassword && !forgotPassword && <>
                <Input
                  placeholder={isLoginCustomers ? 'ID de Cliente' : "Nombre de usuario"}
                  icon="fa fa-user"
                  classNameParent="col-12 mb-3"
                  required
                  defaultValue={session.username}
                  onChange={e => setSession({ ...session, username: e.currentTarget.value })}
                />
                <Input type="password"
                  placeholder="Contraseña"
                  icon="fa fa-lock"
                  classNameParent="col-12 mb-2"
                  required
                  defaultValue={session.password}
                  onChange={e => setSession({ ...session, password: e.currentTarget.value })}
                />
                <CheckBox text="Recordarme" defaultChecked={false} classNameParent="col-12 text-muted" id="remember_me" />
              </>}

              {changePassword && <>
                <Input type="password"
                  placeholder="Nueva Contraseña"
                  icon="fa fa-lock"
                  classNameParent="col-12 mb-2"
                  required
                  defaultValue={newPassword.newPassword}
                  onChange={e => setNewPassword({ ...newPassword, newPassword: e.currentTarget.value })}
                />
                <Input type="password"
                  placeholder="Confirmar Contraseña"
                  icon="fa fa-lock"
                  classNameParent="col-12 mb-2"
                  required
                  defaultValue={newPassword.confirmPassword}
                  onChange={e => setNewPassword({ ...newPassword, confirmPassword: e.currentTarget.value })}
                />
              </>}

              {!forgotPassword && (
                <>
                  <div className="col-12 mt-4">
                    <Button type="submit" variant="primary" block className="system-devs-login-button" style={{ height: '50px' }}>
                      {changePassword ? 'ACTUALIZAR CONTRASEÑA' : 'ENTRAR AL SISTEMA'}
                    </Button>
                  </div>

                  {isLoginCustomers && !changePassword && (
                    <div className="col-12 text-center mt-2">
                      <Button
                        variant="link"
                        size="sm"
                        onClick={(e) => {
                          e.preventDefault();
                          setForgotPassword(true);
                        }}
                      >
                        ¿Olvidaste tu contraseña?
                      </Button>
                    </div>
                  )}
                </>
              )}
            </div>
          </form>}
        </Box.Content>
      </Box.Container>
    </Box>
  </>
}

export default Login
